import { SYSBaseElement, html } from "../../../../../../../_ovlclient/src"

import { T } from "../../../../../../../_ovlclient/src/global/globals"

export class ScreenPackaging extends SYSBaseElement {
  async getUI() {
    let filterHint
    if (
      this.state.app.global.PKG.tables.PKGPackaging.tableDef.PKGPackaging
        .uiState.filter.filterCustom["NotFinished"].active
    ) {
      filterHint = `(${T("PKGPackagingPackagingFilterNotFinished")})`
    } else {
      filterHint = "(Alle)"
    }
    return html`
      <div class="ovl-smart-screen-margins-lr-large">
        <div class="fd-layout-panel ">
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__head">
              <h3 class="fd-layout-panel__title">
                ${T("PKGPackagingPackagingForCustomer", [
                  this.state.app.screens.PKGPackagingCustomerChooser
                    .customerInfo.cardCode,
                  this.state.app.screens.PKGPackagingCustomerChooser
                    .customerInfo.cardName,
                ])}
                ${filterHint}
              </h3>
            </div>
          </div>

          <div class="fd-layout-panel__body">
            <ovl-table class="fd-table" .props=${() => "PKGPackaging"}>
            </ovl-table>
          </div>
        </div>
      </div>
    `
  }
}
